import React, { useState, Suspense, lazy } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import OfflineSyncIndicator from './components/OfflineSyncIndicator';
import ProtectedRoute from './components/ProtectedRoute';
// import Login from './components/Login';
import Login from './login';
import Dashboard from './menu';
import Unauthorized from './components/Unauthorized';
import Home from './home';
import Students from './students';
import Staff from './staff';
import Classes from './class';
import Siren from './siren';
import Announcement from './announcement';
import Circular from './circular';
import Timetable from './timetable';
import Lessonnotes from './lessonnotes';
import Settings from './settings';
import Pricing from './pricing';
import Schoolfees from './schoolfees';
import Messages from './messages';
import Canteenfees from './canteenfees';
import Miscellaneous from './miscellaneous';
import Salaries from './salaries';
import Expenses from './expenses';
import Report from './reportpage';
import Cloud from './cloud';
import Livechat from './livechat';
import AssetManagement from './assetmanagement';
import Academics from './academics';
import VendorOrderForm from './vendor';
import StaffAttendance from './components/StaffAttendance';
import SalesManagement from "./salesManagement";
import Accounting from "./accounting";
import StudentAttendanceDashboard from "./studentAttendanceDashboard";
import AdmissionApplications from "./admissionApplications";
import PublicApplyPage from "./publicAdmission/PublicApplyPage";
import PublicApplicationStatusPage from "./publicAdmission/PublicApplicationStatusPage";
import { Box, CircularProgress } from '@mui/material';

const Canteen = lazy(() => import('./components/app'));

// Create a wrapper component for Home
const HomeWrapper = () => {
    const [loading, setLoading] = useState(false);
    
    return (
        <>
            {loading && (
                <Box sx={{ 
                    position: 'fixed', 
                    top: 0, 
                    left: 0, 
                    width: '100%', 
                    height: '100%', 
                    backgroundColor: 'rgba(0,0,0,0.5)', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    zIndex: 9999 
                }}>
                    <CircularProgress sx={{ color: 'white' }} />
                </Box>
            )}
            <Home setLoader={setLoading} />
        </>
    );
};

function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    {/* Public route */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/apply/:schoolID/status" element={<PublicApplicationStatusPage />} />
                    <Route path="/apply/:schoolID" element={<PublicApplyPage />} />
                    
                    {/* Protected routes */}
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    >
                        <Route path="" element={<HomeWrapper />} />
                        <Route path="students" element={<Students />} />
                        <Route path="admissions" element={<AdmissionApplications />} />
                        <Route path="staff" element={<Staff />} />
                        <Route path="class" element={<Classes />} />
                        <Route path="siren" element={<Siren />} />
                        <Route path="announcement" element={<Announcement />} />
                        <Route path="circular" element={<Circular />} />
                        <Route path="timetable" element={<Timetable />} />
                        <Route path="lessonnotes" element={<Lessonnotes />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="pricing" element={<Pricing />} />
                        <Route path="schoolfees" element={<Schoolfees />} />
                        <Route path="messages" element={<Messages />} />
                        <Route path="accounts" element={<Canteenfees />} />
                        <Route path="miscellaneous" element={<Miscellaneous />} />
                        <Route path="salaries" element={<Salaries />} />
                        <Route path="expenses" element={<Expenses />} />
                        <Route path="sales" element={<SalesManagement />} />
                        <Route
                            path="canteen"
                            element={
                                <Suspense
                                    fallback={
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 6 }}>
                                            <CircularProgress />
                                        </Box>
                                    }
                                >
                                    <Canteen />
                                </Suspense>
                            }
                        />
                        <Route path="report" element={<Report />} />
                        <Route path="accounting" element={<Accounting />} />
                        <Route path="cloudsync" element={<Cloud />} />
                        <Route path="livechat" element={<Livechat />} />
                        <Route path="assetmanagement" element={<AssetManagement />} />
                        <Route path="academics" element={<Academics />} />
                        <Route path="vendor" element={<VendorOrderForm />} />
                        <Route path="staff-attendance" element={<StaffAttendance />} />
                        <Route path="student-attendance" element={<StudentAttendanceDashboard />} />
                    </Route>
                    <Route path="/unauthorized" element={<Unauthorized />} />
                    
                    {/* Catch all route - redirect to login if not authenticated */}
                    <Route
                        path="*"
                        element={
                            <ProtectedRoute>
                                <Navigate to="/" replace />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </AuthProvider>
        </Router>
    );
}

export default App;
